<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue'
import Lenis from '@studio-freight/lenis'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { setLenis } from '../../composable/useLenis.ts' // path may vary

gsap.registerPlugin(ScrollTrigger)

let lenis: Lenis | null = null

onMounted(() => {
  lenis = new Lenis({
    duration: 1.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    orientation: 'vertical',
    gestureOrientation: 'vertical',
    smoothWheel: true,
    touchMultiplier: 2,
  })

  setLenis(lenis) // <- save for use anywhere

  lenis.on('scroll', ScrollTrigger.update)

  function raf(time: number) {
    lenis?.raf(time)
    requestAnimationFrame(raf)
  }

  requestAnimationFrame(raf)
})

onUnmounted(() => {
  if (lenis) lenis.destroy()
  ScrollTrigger.getAll().forEach(trigger => trigger.kill())
})
</script>

<template>
  <div class="scroll-wrapper">
    <slot />
  </div>
</template>

<style scoped>
.scroll-wrapper {
  width: 100%;
  min-height: 100vh;
}
</style>
